// utilies/categoryLabels.js — Phase H
//
// Display-only mapping from the backend's mixed English/Azerbaijani
// category names to clean Azerbaijani labels for the customer storefront.
//
// IMPORTANT: this only touches what the USER SEES.
// The original `category` value is still passed to filters/API/URLs
// (`/products?category=Gift Cards / Balance`) so backend filtering is
// 100% unchanged. Use `getCategoryLabel()` only when rendering text.

// Source-of-truth map. Keys are normalised (lowercased, single-spaced)
// so we can match "Gift Cards / Balance", " gift cards / balance ",
// "Gift cards / balance", etc.
const RAW_MAP = {
    'oyun / gaming':                 'Oyun',
    'streaming / entertainment':     'Yayım və Əyləncə',
    'gift cards / balance':          'Gift Kart və Balans',
    'vpn / security':                'VPN və Təhlükəsizlik',
    'developer / digital tools':     'Developer və Digital Alətlər',
    'marketing & growth':            'Marketinq və İnkişaf',
    'ai services':                   'Süni İntellekt Xidmətləri',
    'accounts marketplace':          'Hesablar Bazarı',
    'design / productivity':         'Dizayn və Məhsuldarlıq',
    'education / language':          'Təhsil və Dil',
    'game':                          'Oyun',
}

// Normalise a category for lookup: lowercase, collapse whitespace, trim.
// Punctuation (/, &, etc.) is preserved because category keys use it.
const normalizeForLookup = (value) => {
    if (value == null) return ''
    return String(value).trim().replace(/\s+/g, ' ').toLowerCase()
}

// Build a stable lookup once.
const LOOKUP = Object.entries(RAW_MAP).reduce((acc, [k, v]) => {
    acc[normalizeForLookup(k)] = v
    return acc
}, {})

// Public — get the display label for a category name.
// Falls back to the original value when we don't have a mapping,
// so unknown / future categories stay visible (rather than disappearing).
export const getCategoryLabel = (categoryName) => {
    if (categoryName == null) return ''
    const original = String(categoryName)
    const hit = LOOKUP[normalizeForLookup(original)]
    return hit || original
}

// Convenience — only for display. Trims whitespace, never changes
// the value passed to filters/API.
export const normalizeCategoryName = (categoryName) =>
    categoryName == null ? '' : String(categoryName).trim()

// Backend value passthrough — exists so call sites that compute both
// a display label and a routing value read identically:
//   const value = getCategoryRouteValue(c.name)  // for URLs/dispatches
//   const label = getCategoryLabel(c.name)       // for UI
// We deliberately do NOT transform the routing value here.
export const getCategoryRouteValue = (categoryName) =>
    categoryName == null ? '' : String(categoryName)

export default {
    getCategoryLabel,
    normalizeCategoryName,
    getCategoryRouteValue,
}
